<template>
  <div class="box" ref="box">
    <master-head-position :nav="nav" />
    <el-row :class="className">
      <slot></slot>
    </el-row>
    <!-- <transition name="el-fade-in">
            <router-view></router-view>
        </transition> -->
  </div>
</template>
<script>
export default {
  data() {
    return {}
  },
  mounted() {
    // window.addEventListener('scroll', this.handleScroll, true)
  },
  methods: {
    // handleScroll () {
    //   //变量scrollTop是滚动条滚动时，距离顶部的距离
    //   var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    //   //变量windowHeight是可视区的高度
    //   var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
    //   //变量scrollHeight是滚动条的总高度
    //   var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
    //   //滚动条到底部的条件
    //   let sum = scrollHeight - (scrollTop + windowHeight)
    //   console.log(scrollTop)
    //   if (scrollTop > 0) {
    //     if (sum > 200) {
    //       this.classA = 'main-bd'
    //     } else {
    //       this.classA = 'main-bdd'
    //     }
    //   }
    // },
  },
  props: {
    nav: {
      type: String,
      default: ''
    },
    className: {
      default: 'main-bd'
    }
  }
}
</script>

<style scoped lang="scss">
@import 'src/assets/sass/mixin';

.main-bd {
  display: none;
}
.main-bdd {
  padding: 30px;
  min-height: 720px;
  background: #fff;
  box-shadow: 0 0 15px rgba(0, 0, 0, 0.05);
  margin-bottom: 210px;
}
.main-bd:last-of-type {
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/page/page-content.vue